import React, { useRef } from "react";
import { FormControl, Card, Layout, Button, usePath, useAppConfig } from "@fdoh/health-ui-react";
import { useHistory, Link, useLocation } from "react-router-dom";
import { useSubmitForm } from "../../hooks/useSubmitForm";
import { useForm } from "react-hook-form";
import { SetBacksInspectionInput, schema, SetBacksInspectionFormProps, ComplianceData } from "./SetBacksInspectionForm.types";
import { useData } from "../../hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import CSS from 'csstype';
import { Constants, InspectionStatus } from "../../helpers/Constants";
import { toast } from "react-toastify";
import { InspectionStatusInput } from "../InspectionHome/InspectionHome.types";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";
// import { usePrettyPrintedState } from './usePrettyPrintedState'


export const SetBacksInspectionForm = (props: SetBacksInspectionFormProps) => {
    const history = useHistory();
    const path = usePath();
    const complianceData = useData<ComplianceData[]>("Compliance") || [];
    const config =  useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
         const user =  useProfile(application) as UserSecurityInput;
     const { control, handleSubmit, setValue, watch } = useForm<SetBacksInspectionInput>({
        defaultValues: props.values,
        resolver: yupResolver(schema),
       
    });
    const yesNoData = [
        { id: "", name: "Please select a value" },
        { id: "Yes", name: "Yes" },
        { id: "No", name: "No" }
    ];
    function timeout(delay: number) {
        return new Promise( res => setTimeout(res, delay) );
    }
    const inspectionStatusData = useData<InspectionStatusInput>("inspectionDetails/" + props.applicationInspectionId);
    const formRef = useRef<HTMLFormElement>(null) ;
    const onSubmit = useSubmitForm<SetBacksInspectionInput>(
        'setBacks',
       async (response) => {
        toast.success("Setbacks saved Successfully");
        await timeout(2000);
        let inspectionStatus = watch("inspectionStatusId");
        if(inspectionStatus == InspectionStatus.Complete){
            if(inspectionStatusData?.filledMoundSystemInspectionId == null 
                || inspectionStatusData?.filledMoundSystemInspectionId == undefined){
                    history.push({
                        pathname: "/filledMoundSystem/",
                        search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                    })
                }
                else {
                    history.push({
                        pathname: "/filledMoundSystem/"+ inspectionStatusData?.filledMoundSystemId,
                        search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                    })
                }
        }
        else if (inspectionStatus == InspectionStatus.Incomplete){
            history.push(`/inspectionDetails/${inspectionStatusData?.applicationInspectionId}`) ;
        }
       
           
        },
        props.action
    );
    const submit = async () => {
        setValue('applicationInspectionId', props.applicationInspectionId ? props.applicationInspectionId : 0);
        if(inspectionStatusData?.setBackInspectionId == null 
            || inspectionStatusData?.setBackInspectionId == undefined){
                setValue('dateCreated', new Date());
                setValue('createdBy', user?.userName);
            }
            else {
                setValue('dateUpdated', new Date());
                setValue('updatedBy', user?.userName);
            }
       
		if (formRef.current) {
           
			formRef.current.dispatchEvent(
				new Event('submit', { cancelable: true, bubbles: true })
			);
            
		}
    }

   
  
    let showSurfaceWaterComment = watch("surfaceWaterComplianceId");
    let showDitchesComment = watch("ditchesComplianceId");
    let showPrivateWellsComment = watch("privateWellsComplianceId");
    let showPublicWellsComment = watch("publicWellsComplianceId");
    let showIrrigationWellsComment = watch("irrigationWellsComplianceId");
    let showPortableWtaerLinesComment = watch("portableWaterLinesComplianceId");
    let showBuildingFoundationComment = watch("buildingFoundationComplianceId");
    let showPropertyLinesComment = watch("propertyLinesComplianceId");
    let showOthersDescription = watch("otherComplianceId");

    let markAllCompliance = watch("markAll");

    const h1Styles: CSS.Properties = {
        float: "right",
       marginTop: '27px'
      };
  const markClick = (e: any) => {
    //showSerfaceWaterComment = markAllCompliance;
    setValue('surfaceWaterComplianceId', markAllCompliance);
    setValue('ditchesComplianceId', markAllCompliance);
    setValue('privateWellsComplianceId', markAllCompliance);
    setValue('publicWellsComplianceId', markAllCompliance);
    setValue('irrigationWellsComplianceId', markAllCompliance);
    setValue('portableWaterLinesComplianceId', markAllCompliance);
    setValue('buildingFoundationComplianceId', markAllCompliance);
    setValue('propertyLinesComplianceId', markAllCompliance);
    setValue('otherComplianceId', markAllCompliance);
    
    e.preventDefault();
      };
     
     
    return (
       
        <form id={props.id} ref={formRef} onSubmit={handleSubmit((data: SetBacksInspectionInput) => onSubmit(data))}>
            <div className="row">
                <div className="col col-md-8">
                    <div className="card-main-title">
                        Setbacks
                    </div>
                </div>
                <div className="col col-md-3 ms-auto">
                    <FormControl.Select
                        control={control}
                        name="markAll"
                        label="Mark All"
                        options={complianceData}
                        required
                    />
                </div>
                <div className="col col-md-1" style={h1Styles}>
                    <Button className="btn btn-primary" onClick={markClick} >Apply</Button>
                </div>
            </div>
           
            <Card.Container>
          
                <Card.Header>
                <Card.Title>{props.title}</Card.Title>
                </Card.Header>
                <Card.Body>
                    <Layout.Row>   <>
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="surfaceWaterComplianceId"
                                    label="Surface Water"
                                    options={complianceData}
                                    required 
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="surfaceWater"
                                    label="Surface Water(ft)"
                                    required= {showSurfaceWaterComment != Constants.Not_Applicable && showSurfaceWaterComment !=Constants.Unobserved }
                                />
                            </div>
                            <FormControl.Hidden
                                    control={control}
                                    name="applicationId"
                                    required
                                />
                        </div>
                        {showSurfaceWaterComment &&
                            showSurfaceWaterComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="surfaceWaterComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="ditchesComplianceId"
                                    label="Ditches"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="ditches"
                                    label="Ditches(ft)"
                                    required= {showDitchesComment != Constants.Not_Applicable && showSurfaceWaterComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showDitchesComment &&
                            showDitchesComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="ditchesComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="privateWellsComplianceId"
                                    label="Private Wells"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="privateWells"
                                    label="Private Wells(ft)"
                                    required= {showPrivateWellsComment != Constants.Not_Applicable && showSurfaceWaterComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showPrivateWellsComment &&
                            showPrivateWellsComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="privateWellsComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="publicWellsComplianceId"
                                    label="Public Wells"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="publicWellsGreaterThan2000GPD"
                                    label="Public Wells >2000 gpd (ft)"
                                    required= {showPublicWellsComment != Constants.Not_Applicable && showSurfaceWaterComment !=Constants.Unobserved }
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="publicWellsLessThan2000GPD"
                                    label="Public Wells <=2000 gpd (ft)"
                                    required= {showPublicWellsComment != Constants.Not_Applicable && showSurfaceWaterComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showPublicWellsComment &&
                            showPublicWellsComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="publicWellsComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="irrigationWellsComplianceId"
                                    label="Irrigation Wells"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="irrigationWells"
                                    label="Irrigation Wells(ft)"
                                    required= {showIrrigationWellsComment != Constants.Not_Applicable && showSurfaceWaterComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showIrrigationWellsComment &&
                            showIrrigationWellsComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="irrigationWellsComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}

                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="portableWaterLinesComplianceId"
                                    label="Potable Water Lines"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-2">
                                <FormControl.Text
                                    control={control}
                                    name="portableWaterLines"
                                    label="Potable Water Lines(ft)"
                                    required= {showPortableWtaerLinesComment != Constants.Not_Applicable && showSurfaceWaterComment !=Constants.Unobserved }
                                />
                            </div>
                            <div className="col col-md-2">
                                <FormControl.Select
                                    control={control}
                                    name="sleevedSealed"
                                    label="Sleeved?"
                                    options={yesNoData}
                                    required= {showPortableWtaerLinesComment != Constants.Not_Applicable && showSurfaceWaterComment !=Constants.Unobserved }
                                />
                            </div>
                            <div className="col col-md-2">
                                <FormControl.Select
                                    control={control}
                                    name="scheduled40Pvc"
                                    label="Schedule 40 PVC?"
                                    options={yesNoData}
                                    required= {showPortableWtaerLinesComment != Constants.Not_Applicable && showSurfaceWaterComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showPortableWtaerLinesComment &&
                            showPortableWtaerLinesComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="portableWaterLinesComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="buildingFoundationComplianceId"
                                    label="Building Foundation"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="buildingFoundation"
                                    label="Building Foundation(ft)"
                                    required= {showBuildingFoundationComment != Constants.Not_Applicable && showSurfaceWaterComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showBuildingFoundationComment &&
                            showBuildingFoundationComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="buildingFoundationComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="propertyLinesComplianceId"
                                    label="Property Lines"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="propertyLines"
                                    label="Property Lines(ft)"
                                    required= {showPropertyLinesComment != Constants.Not_Applicable && showSurfaceWaterComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showPropertyLinesComment &&
                            showPropertyLinesComment == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="propertyLinesComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="otherComplianceId"
                                    label="Other"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="otherSetback"
                                    label="Other(ft)"
                                    required= {showOthersDescription != Constants.Not_Applicable && showOthersDescription != Constants.Unobserved}
                                    />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="otherComment"
                                    label="Description"
                                    
                                />
                            </div>
                        </div>
                        <div className="row">
                            {/*<div className="col col-md-4">*/}
                            {/*    <FormControl.Date*/}
                            {/*        control={control}*/}
                            {/*        name="DateCreated"*/}
                            {/*        label="Created Date"*/}
                            {/*        required*/}
                            {/*    />*/}
                            {/*</div>*/}
                            {/*<div className="col col-md-4">*/}
                            {/*    <FormControl.Text*/}
                            {/*        control={control}*/}
                            {/*        name="createdBy"*/}
                            {/*        label="Created By"*/}
                            {/*        required*/}
                            {/*    />*/}
                            {/*</div>*/}
                            <div className="col col-md-4" hidden>
                                <FormControl.Text
                                    control={control}
                                    name="inspectionStatusId"
                                    label="Created By"
                                    required
                                />
                                   <FormControl.Hidden
                                    control={control}
                                    name="applicationInspectionId"
                                    required
                                />
                            </div>
                            

                        </div>

                    </></Layout.Row>
                </Card.Body>
                <Card.Footer>
                    <div className="d-flex">
                        <span className="btn btn-link" onClick={(e) => {
                            e.preventDefault();
                            setValue('inspectionStatusId', InspectionStatus.Incomplete);
                            submit()

                        }}><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-arrow-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"></path>
                                <path d="M8 12l4 4"></path><path d="M8 12h8"></path>
                                <path d="M12 8l-4 4"></path>
                            </svg> Save and Exit
                        </span>
                        <div className="btn-list ms-auto">
                            <Link
                                to={props.returnPath ?? path.current}
                                className="btn btn-light"
                                role="button"
                            >
                                Cancel
                            </Link>
                            <Button className="btn btn-primary ms-auto" onClick={(e) => {
                               
                                e.preventDefault();
                                setValue('inspectionStatusId', InspectionStatus.Complete);
                                submit()

                            }}>Next</Button>
                        </div>
                    </div>
                </Card.Footer>
            </Card.Container>
        </form>
    );
};

export default SetBacksInspectionForm;




